import { ActivatedRoute, Router } from '@angular/router';
import {
  Component,
  EventEmitter,
  Input,
  Output
  } from '@angular/core';
import { Crumb } from './crumb';


@Component({
  selector: 'nec-crumbs',
  templateUrl: './crumbs.component.html',
  styleUrls: ['./crumbs.component.scss']
})
export class NecCrumbsComponent {
  @Input() crumbs: Crumb[];
  @Input() icon: string;
  @Output() crumbClicked = new EventEmitter<Crumb>();

  constructor(private router: Router, private route: ActivatedRoute) {
  }

  /**
   * å¯¼èªç¹å»äºä»¶
   * @param crumb
   */
  clickCrumb(crumb: Crumb) {
    if (crumb.routeUrl && crumb.autoRoute) {
      this.router.navigate([crumb.routeUrl], { relativeTo: this.route });
    }
    else {
      this.crumbClicked.emit(crumb);
    }
  }
}
